/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Resourcenotfound2Inputs */

const he_server_errors_resourcenotfound2 = /** @type {(inputs: Server_Errors_Resourcenotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המשאב לא נמצא`)
};

const en_server_errors_resourcenotfound2 = /** @type {(inputs: Server_Errors_Resourcenotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource not found`)
};

/**
* | output |
* | --- |
* | "Resource not found" |
*
* @param {Server_Errors_Resourcenotfound2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_resourcenotfound2 = /** @type {((inputs?: Server_Errors_Resourcenotfound2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Resourcenotfound2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_resourcenotfound2(inputs)
	return en_server_errors_resourcenotfound2(inputs)
});
export { server_errors_resourcenotfound2 as "server_errors_resourceNotFound" }